'use strict';

function TruncatableText($wrapper, $trigger) {
  this.$wrapper = $wrapper;
  this.$trigger = $trigger;

  if (this.$wrapper.length) {
    this.$trigger.on('click', this.showText.bind(this));
  }
}

TruncatableText.prototype.showText = function () {
  this.$wrapper.addClass('js-is-active');
};

module.exports = TruncatableText;
